import { defineStore } from 'pinia'
import { useGlobalStore } from './globalStore'

export const useAdvStore = defineStore('advStore', {
  state: () => {
    return {
      showCenter: false, //是否显示间隔banner
      showSponsorCluster: false, //是否显示间隔集群
      events: ['keydown', 'touchstart', 'touchmove', 'touchend', 'click', 'dblclick'], //触发事件
      bannerTimer: '', //间隔banner定时器
      clusterTimer: '', //间隔集群定时器
      isSponsoredAds: true //赞助商广告 用于控制播放视频时全局的赞助商广告不弹出
    }
  },
  actions: {
    startMonitoring() {
      this.stopMonitoring()
      this.events.forEach((event) => {
        document.addEventListener(event, () => {
          this.startCountdownBanner()
          this.startCountdownCluster()
        })
      })
    },
    stopMonitoring() {
      this.events.forEach((event) =>
        window.removeEventListener(event, () => {
          this.startCountdownCluster()
          this.startCountdownCluster()
        })
      )
    },
    //开始计时所有间隔
    startCountdownAll() {
      this.closeCenter()
      this.closeClusterCenter()
      this.isSponsoredAds = true //播放中不允许赞助广告弹窗
    },
    // 关闭 间隔广告-横幅广告
    closeCenter() {
      this.showCenter = false
      this.startCountdownBanner()
    },
    //开启计时
    startCountdownBanner() {
      const { sponsorObj } = storeToRefs(useGlobalStore())
      // 赞助商-横幅广告-间隔时间-frequency
      const countDown = parseInt(sponsorObj.value?.frequency) || 15
      clearTimeout(this.bannerTimer)
      this.bannerTimer = setTimeout(() => {
        this.showCenter = true
      }, countDown * 1000)
    },
    // 关闭赞助商广告-集群广告
    closeClusterCenter() {
      this.showSponsorCluster = false
      this.startCountdownCluster()
    },
    //开启计时
    startCountdownCluster() {
      const { sponsorCluster } = storeToRefs(useGlobalStore())
      // 赞助商-集群广告-间隔时间-frequency
      const countDown = parseInt(sponsorCluster?.value?.[0]?.frequency) || 15
      clearTimeout(this.clusterTimer)
      this.clusterTimer = setTimeout(() => {
        this.showSponsorCluster = true
      }, countDown * 1000)
    }
  },
  // 开始数据持久化
  persist: {
    paths: ['']
  }
})
